/**
 * Полная перезагрузка вкладки (multi-organization-login). После выбора или смены организации
 * кабинет перезагружается целиком: так на экране не остаётся ни состояния страниц, ни данных
 * прежней организации. Вынесено в модуль, чтобы тесты подменяли переход (jsdom его не выполняет).
 */
export function reloadApp(path = '/'): void {
  window.location.assign(path)
}
